import { DropdownButton, MenuItem } from 'react-bootstrap'
import styled, { css } from 'styled-components'

export const Actions = styled.div`
    margin-top: 20px;

    > .dropdown.btn-group {
        margin: 0 8px 12px 0;
    }
`

export const Action = styled.button`
    &.btn {
        margin: 0 8px 12px 0;

        .far {
            margin-right: 8px;
        }
    }

    &:focus {
        outline: none;
    }
`

export const ActionOption = styled(MenuItem)`
    font-family: ${({ theme }) => theme['font-semibold']};

    ${({ color }) =>
        color &&
        css`
            a[role='menuitem'] {
                color: ${color};

                &:hover {
                    color: ${color};
                }
            }
        `}

    .far {
        width: 14px;
        margin-right: 8px;
    }
`

export const ActionWithOptions = styled(DropdownButton)`
    display: inline-block;
    vertical-align: middle;
    height: 34px;

    .btn-options {
        display: inline-block;

        .far {
            margin-right: 8px;
        }
    }
`
